module.exports = __webpack_public_path__ + "a50f82b6d83e8db6d60811a81f3b1a1a.pdf";